/* global AmCharts */

AmCharts.themes.boc = {

    themeName: "boc",

    AmChart: {
        color: "#000000", backgroundColor: "#FFFFFF"
    },

    AmBalloon: {
        cornerRadius: 4,
        shadowAlpha: 0
    },

    AmCoordinateChart: {
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#000000", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#ffffff"]
    },

    AmStockChart: {
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#000000", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#ffffff"]
    },

    AmSlicedChart: {
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#000000", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#ffffff"],
        outlineAlpha: 1,
        outlineThickness: 2,
        labelTickColor: "#000000",
        labelTickAlpha: 0.3
    },

    AmRectangularChart: {
        zoomOutButtonColor: '#000000',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens"
    },

    AxisBase: {
        axisColor: "#000000",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#000000"
    },

    ChartScrollbar: {
        backgroundColor: "#000000",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
    },

    ChartCursor: {
        cursorColor: "#000000",
        color: "#FFFFFF",
        cursorAlpha: 0.5
    },

    AmLegend: {
        color: "#000000"
    },

    AmGraph: {
        lineAlpha: 0.9
    },
    GaugeArrow: {
        color: "#000000",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
    },

    GaugeAxis: {
        tickColor: "#000000",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#000000',
        axisAlpha: 1,
        bandAlpha: 0.8
    },

    TrendLine: {
        lineColor: "#c03246",
        lineAlpha: 0.8
    },

    // ammap
    AreasSettings: {
        alpha: 0.8,
        color: "#67b7dc",
        colorSolid: "#003767",
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#000000",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: "#3c5bdc",
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
    },

    LinesSettings: {
        color: "#000000",
        alpha: 0.8
    },

    ImagesSettings: {
        alpha: 0.8,
        labelColor: "#000000",
        color: "#000000",
        labelRollOverColor: "#3c5bdc"
    },

    ZoomControl: {
        buttonFillAlpha: 0.7,
        buttonIconColor: "#a7a7a7"
    },

    SmallMap: {
        mapColor: "#000000",
        rectangleColor: "#f15135",
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
    },

    // the defaults below are set using CSS syntax, you can use any existing css property
    // if you don't use Stock chart, you can delete lines below
    PeriodSelector: {
        color: "#000000"
    },

    PeriodButton: {
        color: "#000000",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
    },

    PeriodButtonSelected: {
        color: "#000000",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
    },

    PeriodInputField: {
        color: "#000000",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
    },

    DataSetSelector: {

        color: "#000000",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
    },

    DataSetCompareList: {
        color: "#000000",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
    },

    DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
    }

};

AmCharts.themes.bocDark = {

    themeName: "bocDark",

    AmChart: {
        color: "#e7e7e7",
        backgroundColor: "#222222"
    },

    AmBalloon: {
        color: '#fff',
        fillColor: '#1a1820',
        borderThickness: 2,
        cornerRadius: 4,
        shadowAlpha: 0
    },

    AmCoordinateChart: {
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#ffffff", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#000000"]
    },

    AmStockChart: {
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#ffffff", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#000000"]
    },

    AmSlicedChart: {
        outlineAlpha: 1,
        outlineThickness: 2,
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3,
        colors: ["#67b7dc", "#fdd400", "#0eb663", "#b92020", "#f6871e", "#a92c90", "#f089b8", "#8f7456", "#e5c273", "#ee3344", "#0069eb", "#cb7eff", "#006090", "#f8b79c", "#20a0a0", "#375c15", "#b0d050", "#ff5166", "#86346a", "#897cb0", "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", "#6f7800", "#40db47", "#4434a5", "#ffb64e", "#059103", "#ff62dd", "#ffffff", "#c21d61", "#cc6402", "#8f5468", "#194fff", "#5e88f2", "#cd6884", "#c1876b", "#08809c", "#cc0bb2", "#588836", "#9a0cff", "#d1361c", "#a38440", "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", "#5e8892", "#3266ad", "#a07dff", "#000000"]
    },

    AmRectangularChart: {
        zoomOutButtonColor: "#FFFFFF",
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lensWhite"
    },

    AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF",
        dashLength: 3
    },

    ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.2,
        graphFillAlpha: 0.2,
        graphLineAlpha: 0,
        graphFillColor: "#FFFFFF",
        selectedGraphFillColor: "#FFFFFF",
        selectedGraphFillAlpha: 0.4,
        selectedGraphLineColor: "#FFFFFF",
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.09,
        gridAlpha: 0.15
    },

    ChartCursor: {
        cursorColor: "#FFFFFF",
        color: "#000000",
        cursorAlpha: 0.5
    },

    AmLegend: {
        color: "#e7e7e7"
    },

    AmGraph: {
        lineAlpha: 0.9
    },


    GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
    },

    GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: "#FFFFFF",
        axisAlpha: 1,
        bandAlpha: 0.8
    },

    TrendLine: {
        lineColor: "#c03246",
        lineAlpha: 0.8
    },

    // ammap
    AreasSettings: {
        alpha: 0.8,
        color: "#666666",
        colorSolid: "#000000",
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#555555",
        outlineColor: "#000000",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverBrightness: 30,
        slectedBrightness: 50,
        rollOverOutlineColor: "#000000",
        selectedOutlineColor: "#000000",
        unlistedAreasOutlineColor: "#000000",
        unlistedAreasOutlineAlpha: 0.5
    },

    LinesSettings: {
        color: "#555555",
        alpha: 0.8
    },

    ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: "#3c5bdc"
    },

    ZoomControl: {
        buttonFillAlpha: 0.4
    },

    SmallMap: {
        mapColor: "#444444",
        rectangleColor: "#666666",
        backgroundColor: "#000000",
        backgroundAlpha: 0.5,
        borderColor: "#555555",
        borderThickness: 1,
        borderAlpha: 0.8
    },

    // the defaults below are set using CSS syntax, you can use any existing css property
    // if you don't use Stock chart, you can delete lines below
    PeriodSelector: {
        color: "#e7e7e7"
    },

    PeriodButton: {
        color: "#e7e7e7",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(255, 255, 255, .15)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
    },

    PeriodButtonSelected: {
        color: "#e7e7e7",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        border: "1px solid rgba(255, 255, 255, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
    },

    PeriodInputField: {
        color: "#e7e7e7",
        background: "transparent",
        border: "1px solid rgba(255, 255, 255, .15)",
        outline: "none"
    },

    DataSetSelector: {
        color: "#e7e7e7",
        selectedBackgroundColor: "rgba(255, 255, 255, .25)",
        rollOverBackgroundColor: "rgba(255, 255, 255, .15)"
    },

    DataSetCompareList: {
        color: "#e7e7e7",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(255, 255, 255, .15)"
    },

    DataSetSelect: {
        border: "1px solid rgba(255, 255, 255, .15)",
        outline: "none"
    }
};
